import React from 'react';
import { Button } from '@/components/ui/button';

interface BuildListEditorProps {
    nodeState: Record<string, any>;
    setNodeState: (key: string, value: any) => void;
    nodeShape: {
        nodeInPorts: Array<{ name: string; type: any }>;
        nodeInstanceOutPorts: Array<{ name: string; type: any }>;
    };
    updateShape: (shape: { inPorts: Array<{ name: string; type: any }>; outPorts: Array<{ name: string; type: any }> }) => void;
}

const STATE_KEY = 'buildListElements';

function buildElementPorts(elementIndices: number[]) {
    return elementIndices.map(n => ({
        name: `Element ${n}`,
        type: { kind: 'string' as const },
    }));
}

export const BuildListEditor: React.FC<BuildListEditorProps> = props => {
    const elementIndices: number[] = props.nodeState[STATE_KEY] || [];

    const callUpdateShape = (newIndices: number[]) => {
        props.setNodeState(STATE_KEY, newIndices);
    };

    const addElement = () => {
        callUpdateShape([...elementIndices, elementIndices.length + 1]);
    };

    const removeLastElement = () => {
        if (elementIndices.length === 0) return;
        callUpdateShape(elementIndices.slice(0, -1));
    };

    return (
        <div className="flex items-center gap-1 px-2 py-1">
            <Button variant="outline" size="sm" onClick={removeLastElement} disabled={elementIndices.length === 0}>
                -
            </Button>
            <span className="text-xs text-muted-foreground min-w-[4ch] text-center">{elementIndices.length}</span>
            <Button variant="outline" size="sm" onClick={addElement}>
                +
            </Button>
        </div>
    );
};
